webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(26),
  /* template */
  __webpack_require__(63),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(27),
  /* template */
  __webpack_require__(59),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 6 */,
/* 7 */,
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(28),
  /* template */
  __webpack_require__(69),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 9 */
/***/ (function(module, exports) {

/*eslint-disable */
if (!String.prototype.includes) {
  String.prototype.includes = function () {
    return String.prototype.indexOf.apply(this, arguments) !== -1;
  };
}

if (typeof NodeList.prototype.forEach !== "function") {
  NodeList.prototype.forEach = Array.prototype.forEach;
}
/*eslint-enable */

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AppMain__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AppMain___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__AppMain__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AppComplete__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AppComplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__AppComplete__);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'hash',
  linkActiveClass: 'is-active',
  routes: [{
    path: '/',
    name: 'appMain',
    component: __WEBPACK_IMPORTED_MODULE_2__AppMain___default.a
  }, {
    path: '/complete',
    name: 'appComplete',
    component: __WEBPACK_IMPORTED_MODULE_3__AppComplete___default.a
  }]
}));

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(73);


// import createPersistedState from 'vuex-persistedstate';

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  // plugins: [createPersistedState()],
  state: {
    view: 'default', // 'default', 'riddles'
    stage: 0
  },
  mutations: {
    setView: function setView(state, view) {
      state.view = view;
    },
    setStage: function setStage(state, stage) {
      state.stage = stage;
    }
  }
}));

/***/ }),
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(21),
  /* template */
  __webpack_require__(62),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_what_input__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_what_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_what_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_whatwg_fetch__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_whatwg_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_whatwg_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_analytics__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_svg4everybody__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_svg4everybody___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_svg4everybody__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_object_fit_images__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_object_fit_images___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_object_fit_images__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_object_fit_videos__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_object_fit_videos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_object_fit_videos__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_resource__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__custom_polyfills__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__custom_polyfills___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__custom_polyfills__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__App__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__router__ = __webpack_require__(10);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.





// import WebFont from 'webfontloader';











__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_resource__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_analytics___default.a, {
  id: ['UA-28461930-1', 'UA-72599322-1'],
  autoTracking: {
    screenview: true
  },
  debug: {
    sendHitTask: "production" === 'production'
  }
});

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].mixin({
  data: function data() {
    return {
      get baseUrl() {
        return  true ? '' : 'http://localhost:8080/static/';
      }
    };
  }
});

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_11__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_9__App___default.a },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_4_svg4everybody___default()();
    __WEBPACK_IMPORTED_MODULE_5_object_fit_images___default()();
    __WEBPACK_IMPORTED_MODULE_6_object_fit_videos___default()();
    // WebFont.load({
    //   google: {
    //     families: ['Montserrat:300,400'],
    //   },
    //   custom: {
    //     families: ['Jasmine'],
    //   },
    // });
  }
});

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Complete__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Complete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_Complete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Promotions__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Promotions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Promotions__);
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'appComplete',
  components: {
    complete: __WEBPACK_IMPORTED_MODULE_0__pages_Complete___default.a,
    promotions: __WEBPACK_IMPORTED_MODULE_1__components_Promotions___default.a
  }
});

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Home__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_Game__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_Game___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__pages_Game__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Promotions__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Promotions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Promotions__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import Complete from '@/pages/Complete';


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'appMain',
  components: {
    home: __WEBPACK_IMPORTED_MODULE_0__pages_Home___default.a,
    game: __WEBPACK_IMPORTED_MODULE_1__pages_Game___default.a,
    // complete: Complete,
    promotions: __WEBPACK_IMPORTED_MODULE_2__components_Promotions___default.a
  },
  data: function data() {
    return {
      scrolled: false
    };
  },

  computed: {
    view: function view() {
      return this.$store.state.view;
    }
  }
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'entry-form',
  data: function data() {
    return {
      formData: {
        campaign: '5af37c17932ea21d170eb88d',
        firstName: null,
        lastName: null,
        email: null,
        postcode: null,
        termsConditions: false,
        optinSubscription: false,
        passcode: 'inari',
        utm_source: 'source',
        utm_campaign: '',
        utm_medium: ''
      },
      success: false,
      fnameError: false,
      lnameError: false,
      emailError: false,
      postcodeError: false,
      termsError: false,
      loading: false
    };
  },

  computed: {
    stage: {
      get: function get() {
        return this.$store.state.stage;
      },
      set: function set(value) {
        this.$store.commit('setStage', value);
      }
    }
  },
  methods: {
    validateEmail: function validateEmail(email) {
      var re = /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@(([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      return re.test(email);
    },
    validateText: function validateText(value) {
      if (value === null || value === '') return false;
      return true;
    },
    validatePostcode: function validatePostcode(value) {
      if (value === null || value === '' || value.length !== 4 || parseInt(value, 10) > 9999) return false;
      return true;
    },
    validateForm: function validateForm() {
      // check fname
      if (!this.validateText(this.formData.firstName)) this.fnameError = true;else this.fnameError = false;

      // check lname
      if (!this.validateText(this.formData.lastName)) this.lnameError = true;else this.lnameError = false;

      // validate email
      if (!this.validateEmail(this.formData.email)) this.emailError = true;else this.emailError = false;

      // check postcode
      if (!this.validatePostcode(this.formData.postcode)) this.postcodeError = true;else this.postcodeError = false;

      // check terms
      this.termsError = !this.formData.termsConditions;

      // check for any errors
      if (this.fnameError || this.lnameError || this.emailError || this.postcodeError || this.termsError) {
        return false;
      }

      // success
      return true;
    },
    submitEnter: function submitEnter() {
      var _this = this;

      // return if invalid
      if (!this.validateForm()) return;
      this.loading = true;

      this.$nextTick(function () {
        var data = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, _this.formData);
        data.termsConditions = data.termsConditions.toString();
        data.optinSubscription = data.optinSubscription.toString();

        _this.$http.post('https://repopul8.circul8.com.au/api/save/', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data)).then(function (response) {
          // success
          if (response.body.status === 'ok') {
            console.log('success: ', response);
            _this.$ga.event('SecretScrolls', 'Click', 'Submit');
            // this.$store.commit('setView', 'complete');
            _this.$router.push({ path: 'complete' });
            window.scrollTo(0, 0);
          } else {
            console.log('error: ', response);
          }
        }, function (response) {
          // error
          console.log('error: ', response);
        }).then(function () {
          _this.loading = false;
        });
      });
    },
    getParameterByName: function getParameterByName(name, url) {
      var currentUrl = url || window.location.href;
      var regex = new RegExp('[?&]' + name.replace(/[[\]]/g, '\\$&') + '(=([^&#]*)|&|#|$)');
      var results = regex.exec(currentUrl);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }
  },
  mounted: function mounted() {
    this.formData.utm_source = this.getParameterByName('utm_source');
    this.formData.utm_campaign = this.getParameterByName('utm_campaign');
    this.formData.utm_medium = this.getParameterByName('utm_medium');
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'final-riddle',
  data: function data() {
    return {
      finalAnswer: null,
      finalAnswerError: false,
      randomIndex: 0,
      checkingAnswer: false,
      questions: [{
        question: 'How many original Japanese castles still remain with an intact main tower?',
        answer: '12',
        hint: 'Between 10 and 15'
      }, {
        question: 'Izumo Taisha Grand Shrine in Shimane Prefecture has been awarded how many stars by the Michelin Green Guide Japan?',
        answer: '2',
        hint: 'Between 1 and 5'
      }, {
        question: 'Nachi Waterfall in Wakayama Prefecture is the tallest waterfall in Japan. How tall is it in metres?',
        answer: '133',
        hint: 'Between 130 and 135'
      }, {
        question: 'What year will Japan host the Rugby World Cup?',
        answer: '2019',
        hint: 'Between 2018 and 2024'
      }, {
        question: 'Several islands in the Seto Inland Sea including the art island of Naoshima host the contemporary arts festival ‘Setouchi Triennale’ every how many years?',
        answer: '3',
        hint: 'Between 1 and 5'
      }, {
        question: 'On the famous Shikoku Henro pilgrimage walk, how many temples do you have the chance to explore?',
        answer: '88',
        hint: 'Between 85 and 90'
      }, {
        question: 'How many prefectures are there in Japan?',
        answer: '47',
        hint: 'Between 45 and 50'
      }, {
        question: 'How many major sumo tournaments are held in Japan every year?',
        answer: '6',
        hint: 'Between 5 and 10'
      }, {
        question: 'What year will Tokyo next hold the Summer Olympic and Paralympic Games?',
        answer: '2020',
        hint: 'Between 2019 and 2030'
      }, {
        question: 'How many UNESCO world heritage sites are there in Japan?',
        answer: '21',
        hint: 'Between 20 and 25'
      }]
    };
  },

  computed: {
    stage: {
      get: function get() {
        return this.$store.state.stage;
      },
      set: function set(value) {
        this.$store.commit('setStage', value);
      }
    }
  },
  methods: {
    submitFinal: function submitFinal() {
      var _this = this;

      this.checkingAnswer = true;

      setTimeout(function () {
        if (_this.finalAnswer !== _this.questions[_this.randomIndex].answer) {
          _this.finalAnswerError = true;
        } else {
          _this.finalAnswerError = false;
          _this.$ga.event('SecretScrolls', 'Click', 'Take Me There');
          _this.stage = 6;
        }
        _this.checkingAnswer = false;
      }, 500);
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$nextTick(function () {
      _this2.randomIndex = Math.floor(Math.random() * _this2.questions.length);
    });
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'icon',
  props: {
    name: {
      type: String,
      required: true
    },
    role: {
      type: String,
      default: 'presentation'
    },
    label: {
      type: String
    }
  }
});

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'main-header'
});

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'promotions',
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_0__components_Icon___default.a
  },
  data: function data() {
    return {
      promotions: [{
        from: 'Perth',
        to: 'Osaka',
        price: '349'
      }, {
        from: 'Sydney',
        to: 'Osaka',
        price: '349'
      }, {
        from: 'Perth',
        to: 'Tokyo',
        price: '349'
      }, {
        from: 'Melbourne',
        to: 'Osaka',
        price: '349'
      }]
    };
  }
});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_tiny_slider__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_tiny_slider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_tiny_slider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Icon__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_MainHeader__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_MainHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_MainHeader__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'complete',
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_1__components_Icon___default.a,
    MainHeader: __WEBPACK_IMPORTED_MODULE_2__components_MainHeader___default.a,
    TinySlider: __WEBPACK_IMPORTED_MODULE_0_vue_tiny_slider___default.a
  },
  data: function data() {
    return {
      isMobile: true
    };
  },

  methods: {
    checkWindow: function checkWindow() {
      if (window.innerWidth < 960) this.isMobile = true;else this.isMobile = false;
    },
    onResize: function onResize() {
      var mobile = this.isMobile;
      this.checkWindow();
      if (this.isMobile === mobile) return;
      if (this.isMobile) {
        this.$refs.stepsSlider.rebuild();
        this.$refs.passionsSlider.rebuild();
      } else {
        this.$refs.stepsSlider.destroy();
        this.$refs.passionsSlider.destroy();
      }
    },
    popup: function popup(type) {
      var url = void 0;
      switch (type) {
        case 'Facebook':
          url = 'https://www.facebook.com/sharer.php?u=https://www.jnto.org.au/secretscrolls?utm_medium=Facebook&utm_source=Website&utm_campaign=SecretScrolls';
          break;
        case 'Twitter':
          url = 'https://twitter.com/intent/tweet?text=Can you unlock the Secret Scrolls of Ikigai? Find out for your chance to win return flights to Japan for you and your friend.&url=https%3A//www.jnto.org.au/secretscrolls?utm_medium=Twitter%26utm_source=Website%26utm_campaign=SecretScrolls';
          break;
        default:
          url = '';
      }

      this.$ga.event('ResultsPage', 'Click', 'Share' + type);

      var width = 576;
      var height = 256;
      var left = Math.ceil((window.innerWidth - width) / 2) + (window.screenLeft || window.screen.left);
      var top = Math.ceil((window.innerHeight - height) / 2) + (window.screenTop || window.screen.top);

      var options = 'status=1,width=' + width + ',height=' + height + ',left=' + left + ',top=' + top;
      window.open(url, '_blank', options);
    }
  },
  mounted: function mounted() {
    this.onResize();
    window.addEventListener('resize', this.onResize);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  }
});

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FinalRiddle__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FinalRiddle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_FinalRiddle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_EntryForm__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_EntryForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_EntryForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_MainHeader__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_MainHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_MainHeader__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'game',
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_0__components_Icon___default.a,
    EntryForm: __WEBPACK_IMPORTED_MODULE_2__components_EntryForm___default.a,
    FinalRiddle: __WEBPACK_IMPORTED_MODULE_1__components_FinalRiddle___default.a,
    MainHeader: __WEBPACK_IMPORTED_MODULE_3__components_MainHeader___default.a
  },
  data: function data() {
    return {
      formActive: false,
      recentlyCorrect: true,
      checkingAnswer: false,
      animateInari: false,
      inariAnim: null,
      inariText: ['SUGOI! <span>(awesome!)</span>', 'Try Again!'],
      answerStates: ['', '', '', '', ''],
      hints: ['Mount Fuj_', 'Bullet Trai_', 'R_men noodles', 'Ai_ Asia', 'Sush_'],
      answers: ['', '', '', '', ''],
      cursor: 'left',
      showEntryForm: false,
      correctAnswers: ['I', 'N', 'A', 'R', 'I'],
      riddles: [[{
        img: '1-1.svg',
        imgWidth: 108,
        text: 'I am a shrine with a miracle on water - a ‘floating’ torii gate. I am a UNESCO World Heritage listed site.'
      }, {
        img: '1-2.svg',
        imgWidth: 85,
        text: 'Prepare yourself for bowl after bowl of soba noodles. It’s Wanko soba time, which originated in this Japanese prefecture.'
      }, {
        img: 'airasia.svg',
        imgWidth: 98,
        text: 'The top 3 busiest railway stations in the world are in Tokyo. They are 1) Shinjuku 2) Shibuya and 3) ?'
      }], [{
        img: '2-1.svg',
        imgWidth: 100,
        text: 'From up here on Mount Inasa, I offer you one of the top 3 most spectacular night views in Japan. Which city am I?'
      }, {
        img: '2-2.svg',
        imgWidth: 93,
        text: 'Things are about to get even hotter in ‘Hell Valley’ with this famous onsen in Hokkaido.'
      }, {
        img: 'airasia.svg',
        imgWidth: 98,
        text: 'I’m an entertainment district and major city centre located in southern Osaka.'
      }], [{
        img: '3-1.svg',
        imgWidth: 92,
        text: 'Put on your dancing shoes, it’s time for Japan’s largest dance festival in Tokushima prefecture on the island of Shikoku.'
      }, {
        img: '3-2.svg',
        imgWidth: 88,
        text: 'I am an island in Ehime prefecture inhabited by more cats than humans.'
      }, {
        img: 'airasia.svg',
        imgWidth: 98,
        text: 'I am a prefecture in Tohoku famous for apples and the famous Nebuta Festival.'
      }], [{
        img: '4-1.svg',
        imgWidth: 109,
        text: 'I am a traditional Japanese-style inn usually found near onsen (hot springs).'
      }, {
        img: '4-2.svg',
        imgWidth: 83,
        text: 'I belong to an indigenous group that resides in Okinawa. Our language, food and arts are distinctly different from the rest of Japan. What am I?'
      }, {
        img: 'airasia.svg',
        imgWidth: 98,
        text: 'I am a hearty bowl of egg noodles, often served in a broth made of pork-bone, soy, salt or miso.'
      }], [{
        img: '5-1.svg',
        imgWidth: 101,
        text: 'Warm your soul in Hokkaido with this local speciality hot pot dish that features salmon as its star ingredient.'
      }, {
        img: '5-2.svg',
        imgWidth: 87,
        text: 'I am a Japanese-style informal pub where people come to eat, drink and unwind.'
      }, {
        img: 'airasia.svg',
        imgWidth: 98,
        text: 'I am Okinawa’s 3rd largest island, home to the sparkling blue waters of Kabira Bay.'
      }]],
      inititalInit: false,
      ctrlDown: false
    };
  },

  computed: {
    stage: {
      get: function get() {
        return this.$store.state.stage;
      },
      set: function set(value) {
        this.$store.commit('setStage', value);
      }
    }
  },
  methods: {
    gameOn: function gameOn() {
      if (this.stage > 4) return;
      this.formActive = true;
      this.$refs.formItem[this.stage].getElementsByTagName('input')[0].focus();
      if (!this.inititalInit) {
        this.$ga.event('SecretScrolls', 'Click', 'Field ' + (this.stage + 1));
        this.inititalInit = true;
      }
      this.expandRiddleSection();
    },
    gameOff: function gameOff() {
      if (this.stage > 4) return;
      if (this.checkingAnswer) return;
      this.formActive = false;
      this.$refs.formItem[this.stage].getElementsByTagName('input')[0].blur();
      this.collapseRiddleSection();
    },
    update: function update(e) {
      var _this = this;

      e.preventDefault();
      var val = e.target.value.charAt(e.target.value.length - 1).toUpperCase();
      var inputEl = e.target;
      inputEl.value = val.charAt(0);
      if (this.checkingAnswer) return;
      if (val.length === 0) {
        this.$set(this.answerStates, this.stage, '');
        return;
      }
      this.checkingAnswer = true;
      var currentStage = this.stage;
      this.answers[this.stage] = val.charAt(0);
      this.$set(this.answerStates, this.stage, 'c-answer-form__item--loading');
      setTimeout(function () {
        if (_this.answers[_this.stage] === _this.correctAnswers[_this.stage]) {
          _this.$set(_this.answerStates, _this.stage, 'c-answer-form__item--correct');
          _this.recentlyCorrect = true;
          _this.collapseRiddleSection();
          if (_this.stage >= 4) _this.initFinalAnswer();else setTimeout(function () {
            return _this.nextRiddle();
          }, 500);
        } else {
          _this.recentlyCorrect = false;
          _this.$set(_this.answerStates, _this.stage, 'c-answer-form__item--incorrect');
        }
        if (_this.answers[currentStage] !== '') {
          _this.animateInari = true;
          clearTimeout(_this.inariAnim);
          _this.inariAnim = setTimeout(function () {
            _this.animateInari = false;
          }, 3000);
        }
        if (!_this.recentlyCorrect) {
          _this.checkingAnswer = false;
          _this.$nextTick(function () {
            _this.$refs.formItem[_this.stage].getElementsByTagName('input')[0].focus();
          });
        }
      }, 1000);
    },
    nextRiddle: function nextRiddle() {
      var _this2 = this;

      this.stage = this.stage + 1;
      this.$ga.event('SecretScrolls', 'Click', 'Field ' + (this.stage + 1));
      // this.$store.commit('setStage', this.stage + 1);
      this.checkingAnswer = false;
      this.expandRiddleSection();
      this.$nextTick(function () {
        _this2.$refs.formItem[_this2.stage].getElementsByTagName('input')[0].focus();
      });
    },
    initFinalAnswer: function initFinalAnswer() {
      this.$ga.event('SecretScrolls', 'Click', 'Field 6 Wildcard');
      this.$store.commit('setStage', 5);
      this.formActive = false;
      // this.$refs.finalRiddle.getElementsByTagName('input')[0].focus();
    },
    expandRiddleSection: function expandRiddleSection() {
      var _this3 = this;

      this.$nextTick(function () {
        var element = _this3.$refs.riddleContent;
        var sectionHeight = element.scrollHeight;
        requestAnimationFrame(function () {
          element.style.height = sectionHeight + 'px';
        });
      });
    },
    collapseRiddleSection: function collapseRiddleSection() {
      var _this4 = this;

      requestAnimationFrame(function () {
        _this4.$refs.riddleContent.style.height = 0;
      });
    }
  }
});

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_MainHeader__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_MainHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_MainHeader__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_0__components_Icon___default.a,
    MainHeader: __WEBPACK_IMPORTED_MODULE_1__components_MainHeader___default.a
  },
  methods: {
    start: function start() {
      this.$store.commit('setView', 'riddles');
      this.$ga.event('SecretScrolls', 'Click', 'Begin Game');
      window.scrollTo(0, 0);
    }
  }
});

/***/ }),
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 50 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 51 */,
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(50)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(22),
  /* template */
  __webpack_require__(67),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(49)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(23),
  /* template */
  __webpack_require__(66),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(24),
  /* template */
  __webpack_require__(64),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(25),
  /* template */
  __webpack_require__(68),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(29),
  /* template */
  __webpack_require__(65),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(30),
  /* template */
  __webpack_require__(60),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(31),
  /* template */
  __webpack_require__(61),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 59 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "c-header"
  }, [_c('a', {
    staticClass: "c-header__logo",
    attrs: {
      "href": "https://www.airasia.com/en/home.page?utm_medium=display&utm_source=jnto&utm_campaign=d7_au_ptmkt%7Cjnto%7C04062018%7Cau-en",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.$ga.event('SecretScrolls', 'Click', 'AirAsia Logo Top');
      }
    }
  }, [_c('img', {
    attrs: {
      "src": (_vm.baseUrl + "img/airasia.svg"),
      "alt": "AirAsia"
    }
  })]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_c('span', [_vm._v("The secret scrolls of")]), _vm._v("Ikigai")])
}]}

/***/ }),
/* 60 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "c-section c-section--game"
  }, [_c('div', {
    staticClass: "o-container o-container--small"
  }, [_c('main-header'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "c-answers",
    class: {
      'c-answers--complete': _vm.stage > 4
    }
  }, [_c('div', {
    staticClass: "c-answers__wrap"
  }, [_c('div', {
    staticClass: "c-answers__chest"
  }), _vm._v(" "), _c('div', {
    staticClass: "c-inari c-answers__inari",
    class: {
      'c-inari--active': _vm.stage <= 4
    }
  }, [_c('div', {
    staticClass: "c-answers__bubble",
    class: {
      'c-answers__bubble--animate': _vm.animateInari, 'c-answers__bubble--correct': _vm.recentlyCorrect, 'c-answers__bubble--incorrect': !_vm.recentlyCorrect
    }
  }, [(!_vm.recentlyCorrect) ? _c('div', [_vm._v("Try Again!")]) : _vm._e(), _vm._v(" "), (_vm.recentlyCorrect) ? _c('div', [_vm._v("SUGOI! "), _c('span', [_vm._v("(awesome!)")])]) : _vm._e()]), _vm._v(" "), _c('img', {
    attrs: {
      "src": (_vm.baseUrl + "img/inari.svg"),
      "alt": "INARI"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "c-answers__hint",
    class: {
      'c-answers__hint--active': !_vm.recentlyCorrect
    }
  }, [_vm._v(_vm._s(_vm.hints[_vm.stage]))]), _vm._v(" "), _c('form', {
    staticClass: "c-answer-form",
    on: {
      "click": _vm.gameOn
    }
  }, _vm._l((5), function(n, index) {
    return _c('div', {
      ref: "formItem",
      refInFor: true,
      staticClass: "c-answer-form__item",
      class: [_vm.answerStates[index], {
        'c-answer-form__item--active': _vm.stage === index && _vm.formActive
      }]
    }, [_c('div', {
      staticClass: "c-answer-form__icon"
    }), _vm._v(" "), _c('div', {
      staticClass: "c-anwer-form__answer"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.answers[index]),
        expression: "answers[index]"
      }],
      staticClass: "riddle-input",
      attrs: {
        "type": "text",
        "maxlength": "2",
        "placeholder": "?",
        "disabled": _vm.checkingAnswer || index < _vm.stage
      },
      domProps: {
        "value": (_vm.answers[index])
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.answers, index, $event.target.value)
        }, _vm.update],
        "focus": _vm.gameOn,
        "blur": _vm.gameOff
      }
    }), _vm._v(" "), _c('span', {
      class: {
        'c-answer--ready': _vm.answers[index] === ''
      }
    }, [_vm._v(_vm._s(_vm.answers[index] ? _vm.answers[index] : '?'))])])])
  }))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.stage < 5),
      expression: "stage < 5"
    }],
    ref: "riddleSection",
    staticClass: "c-riddles",
    class: {
      'c-riddles--active': _vm.formActive
    }
  }, [_c('div', {
    staticClass: "c-scroll c-scroll--large"
  }, [_c('img', {
    staticClass: "c-scroll__top",
    attrs: {
      "src": (_vm.baseUrl + "img/scroll/top.svg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "c-scroll__middle"
  }, [_c('svg', {
    staticClass: "c-scroll__shadow c-scroll__shadow--top",
    attrs: {
      "width": "532.4",
      "height": "81.16",
      "preserveAspectRatio": "xMinYMin meet",
      "viewBox": "0 0 532.4 81.16",
      "role": "presentation"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#cfa973",
      "d": "M532.4 0v43.72L0 81.16V0z"
    }
  })]), _vm._v(" "), _c('div', {
    ref: "riddleContent",
    staticClass: "c-riddles__content"
  }, [_c('header', [_c('h3', [_vm._v("Scroll " + _vm._s(_vm.stage + 1))]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('ul', {
    staticClass: "c-riddles__list"
  }, _vm._l((_vm.riddles[_vm.stage]), function(riddle, index) {
    return _c('li', [_c('div', {
      staticClass: "c-riddles__icon"
    }, [_c('img', {
      attrs: {
        "src": (_vm.baseUrl + "img/riddles/" + (riddle.img)),
        "width": riddle.imgWidth,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "c-riddles__text s-entry-content"
    }, [_c('p', [_c('strong', [_vm._v("Riddle " + _vm._s(index + 1))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(riddle.text))])])])
  }))]), _vm._v(" "), _c('svg', {
    staticClass: "c-scroll__shadow c-scroll__shadow--bottom",
    attrs: {
      "width": "532.4",
      "height": "81.28",
      "preserveAspectRatio": "xMinYMax meet",
      "viewBox": "0 0 532.4 81.28",
      "role": "presentation"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#cfa973",
      "d": "M0 12.28L532.4 0v81.28H0z"
    }
  })])]), _vm._v(" "), _c('img', {
    staticClass: "c-scroll__bottom",
    attrs: {
      "src": (_vm.baseUrl + "img/scroll/bottom.svg"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('final-riddle', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.stage === 5),
      expression: "stage === 5"
    }]
  }), _vm._v(" "), (_vm.stage === 6) ? _c('entry-form') : _vm._e()], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-instructions s-entry-content"
  }, [_c('h3', [_vm._v("How to play")]), _vm._v(" "), _c('p', [_vm._v("Clear your mind of all distractions. That means stop eating too! It’s time to solve some riddles.")]), _vm._v(" "), _c('p', [_vm._v("To unlock the secrets of ikigai, you must tell me the correct 5-letter passcode and answer a final question correctly. Each letter of the passcode contains a scroll with 3 riddles. Their answers all begin with the letter that you must enter above the scroll.")]), _vm._v(" "), _c('p', [_vm._v("If you make an incorrect attempt, I will provide a hint to help.")]), _vm._v(" "), _c('p', [_vm._v("Good luck!")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("All answers begin with the letter you seek.")])])
}]}

/***/ }),
/* 61 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "c-section c-section--home"
  }, [_c('div', {
    staticClass: "o-container"
  }, [_c('div', {
    staticClass: "c-inari c-inari--home"
  }, [_c('img', {
    attrs: {
      "src": (_vm.baseUrl + "img/inari.svg"),
      "alt": "INARI"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "c-home-columns"
  }, [_c('div', {
    staticClass: "c-home-column c-home-column--1"
  }, [_c('main-header'), _vm._v(" "), _c('div', {
    staticClass: "c-arrow-down"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('button', {
    staticClass: "c-button c-button--primary c-button--large c-button--start",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.start($event)
      }
    }
  }, [_vm._v("Begin game")])], 1), _vm._v(" "), _c('div', {
    staticClass: "c-home-column c-home-column--2"
  }, [_c('div', {
    staticClass: "c-scroll c-scroll--home c-scroll--small"
  }, [_c('img', {
    staticClass: "c-scroll__top",
    attrs: {
      "src": (_vm.baseUrl + "img/scroll/top.svg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "c-scroll__middle"
  }, [_c('svg', {
    staticClass: "c-scroll__shadow c-scroll__shadow--top",
    attrs: {
      "width": "532.4",
      "height": "81.16",
      "preserveAspectRatio": "xMinYMin meet",
      "viewBox": "0 0 532.4 81.16",
      "role": "presentation"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#cfa973",
      "d": "M532.4 0v43.72L0 81.16V0z"
    }
  })]), _vm._v(" "), _c('header', [_c('h2', [_vm._v("\n                  Win flights"), _c('br'), _vm._v(" "), _c('span', [_vm._v("\n                    to Japan\n                    "), _c('small', [_vm._v("with")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.airasia.com/en/home.page?utm_medium=display&utm_source=jnto&utm_campaign=d7_au_ptmkt%7Cjnto%7C04062018%7Cau-en",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.$ga.event('SecretScrolls', 'Click', 'AirAsia Logo Side');
      }
    }
  }, [_c('img', {
    attrs: {
      "src": (_vm.baseUrl + "img/airasia.svg"),
      "alt": "AirAsia"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "c-arrow-down c-arrow-down--mobile"
  }), _vm._v(" "), _c('button', {
    staticClass: "c-button c-button--primary c-button--start",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.start($event)
      }
    }
  }, [_vm._v("Begin game")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('img', {
    staticClass: "c-scroll__shadow c-scroll__shadow--bottom",
    attrs: {
      "src": (_vm.baseUrl + "img/scroll/shadow-bottom-japan.svg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('img', {
    staticClass: "c-scroll__bottom",
    attrs: {
      "src": (_vm.baseUrl + "img/scroll/bottom.svg"),
      "alt": ""
    }
  })])])])]), _vm._v(" "), _vm._m(2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "lead"
  }, [_vm._v("In Japan, finding your "), _c('strong', [_vm._v("ikigai")]), _vm._v(" is when you discover your true passion and reason for being.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "s-entry-content"
  }, [_c('p', [_vm._v("Welcome old friend. I gather you are here because you heard about the Secret Scrolls of Ikigai. Remember, journeys worth taking are never easy.")]), _vm._v(" "), _c('p', [_vm._v("In Japan, we believe that the pursuit of your true passion can lead to unthinkably wonderful things. What are they? That’s for you to find out.")]), _vm._v(" "), _c('p', [_vm._v("Your journey to all the answers begin here. To unlock the secrets of ikigai, you must solve a series of riddles. If you are successful, you will have the chance to "), _c('strong', [_vm._v("win return flights to Japan")]), _vm._v(" for you and a friend and step closer to discovering your ikigai in Japan.")]), _vm._v(" "), _c('p', [_vm._v("Are you ready?")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-divider-arrow"
  }, [_c('div', {
    staticClass: "c-arrow-down"
  })])
}]}

/***/ }),
/* 62 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 63 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    staticClass: "o-icon",
    attrs: {
      "width": "24",
      "height": "24",
      "focusable": "false",
      "role": _vm.role,
      "aria-label": _vm.label
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": (_vm.baseUrl + "img/icons.svg#icon-" + _vm.name)
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 64 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-enter"
  }, [_c('div', {
    staticClass: "c-inari c-enter__inari",
    class: {
      'c-inari--active': _vm.stage === 6
    }
  }, [_c('img', {
    attrs: {
      "src": (_vm.baseUrl + "img/inari.svg"),
      "alt": "INARI"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "c-enter__airasia"
  }, [_c('a', {
    attrs: {
      "href": "https://www.airasia.com/en/home.page?utm_medium=display&utm_source=jnto&utm_campaign=d7_au_ptmkt%7Cjnto%7C04062018%7Cau-en",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.$ga.event('SecretScrolls', 'Click', 'AirAsia Small Entry Logo');
      }
    }
  }, [_c('img', {
    attrs: {
      "src": (_vm.baseUrl + "img/airasia.svg"),
      "alt": "AirAsia"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "c-scroll c-scroll--large c-enter"
  }, [_c('img', {
    staticClass: "c-scroll__top",
    attrs: {
      "src": (_vm.baseUrl + "img/scroll/top.svg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "c-scroll__middle"
  }, [_c('svg', {
    staticClass: "c-scroll__shadow c-scroll__shadow--top",
    attrs: {
      "width": "532.4",
      "height": "81.16",
      "preserveAspectRatio": "xMinYMin meet",
      "viewBox": "0 0 532.4 81.16",
      "role": "presentation"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#cfa973",
      "d": "M532.4 0v43.72L0 81.16V0z"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "c-enter__content"
  }, [_vm._m(0), _vm._v(" "), _c('form', {
    staticClass: "c-form"
  }, [_c('div', {
    staticClass: "c-input-field",
    class: {
      'c-form-error': _vm.fnameError
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.firstName),
      expression: "formData.firstName"
    }],
    attrs: {
      "type": "text",
      "name": "name",
      "id": "name",
      "placeholder": "First name"
    },
    domProps: {
      "value": (_vm.formData.firstName)
    },
    on: {
      "focus": function($event) {
        _vm.$ga.event('SecretScrolls', 'Click', 'First Name');
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "firstName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "c-error-message"
  }, [_vm._v("Please enter your first name")])]), _vm._v(" "), _c('div', {
    staticClass: "c-input-field",
    class: {
      'c-form-error': _vm.lnameError
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.lastName),
      expression: "formData.lastName"
    }],
    attrs: {
      "type": "text",
      "name": "name",
      "id": "name",
      "placeholder": "Last name"
    },
    domProps: {
      "value": (_vm.formData.lastName)
    },
    on: {
      "focus": function($event) {
        _vm.$ga.event('SecretScrolls', 'Click', 'Last Name');
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "lastName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "c-error-message"
  }, [_vm._v("Please enter your last name")])]), _vm._v(" "), _c('div', {
    staticClass: "c-input-field",
    class: {
      'c-form-error': _vm.emailError
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.email),
      expression: "formData.email"
    }],
    attrs: {
      "type": "email",
      "name": "email",
      "id": "email",
      "placeholder": "Email address"
    },
    domProps: {
      "value": (_vm.formData.email)
    },
    on: {
      "focus": function($event) {
        _vm.$ga.event('SecretScrolls', 'Click', 'Email Address');
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "c-error-message"
  }, [_vm._v("Please enter a valid personal email address")])]), _vm._v(" "), _c('div', {
    staticClass: "c-input-field",
    class: {
      'c-form-error': _vm.postcodeError
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.postcode),
      expression: "formData.postcode"
    }],
    attrs: {
      "type": "number",
      "name": "postcode",
      "id": "postcode",
      "min": "0",
      "max": "9999",
      "placeholder": "Postcode"
    },
    domProps: {
      "value": (_vm.formData.postcode)
    },
    on: {
      "focus": function($event) {
        _vm.$ga.event('SecretScrolls', 'Click', 'Post code');
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "postcode", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "c-error-message"
  }, [_vm._v("Please enter a valid postcode within Australia")])]), _vm._v(" "), _c('div', {
    staticClass: "c-input-field c-input-field--padtop c-checkbox",
    class: {
      'c-form-error': _vm.termsError
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.termsConditions),
      expression: "formData.termsConditions"
    }],
    attrs: {
      "type": "checkbox",
      "name": "terms",
      "id": "terms",
      "value": "Agree"
    },
    domProps: {
      "checked": Array.isArray(_vm.formData.termsConditions) ? _vm._i(_vm.formData.termsConditions, "Agree") > -1 : (_vm.formData.termsConditions)
    },
    on: {
      "click": function($event) {
        _vm.$ga.event('SecretScrolls', 'Click', 'Terms');
      },
      "change": function($event) {
        var $$a = _vm.formData.termsConditions,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Agree",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.formData.termsConditions = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.formData.termsConditions = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.formData, "termsConditions", $$c)
        }
      }
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('small', {
    staticClass: "c-error-message"
  }, [_vm._v("Please confirm the above.")])]), _vm._v(" "), _c('div', {
    staticClass: "c-input-field c-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.optinSubscription),
      expression: "formData.optinSubscription"
    }],
    attrs: {
      "type": "checkbox",
      "name": "subscribe",
      "id": "subscribe",
      "value": "Agree"
    },
    domProps: {
      "checked": Array.isArray(_vm.formData.optinSubscription) ? _vm._i(_vm.formData.optinSubscription, "Agree") > -1 : (_vm.formData.optinSubscription)
    },
    on: {
      "click": function($event) {
        _vm.$ga.event('SecretScrolls', 'Click', 'Newsletter');
      },
      "change": function($event) {
        var $$a = _vm.formData.optinSubscription,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Agree",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.formData.optinSubscription = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.formData.optinSubscription = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.formData, "optinSubscription", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "subscribe"
    }
  }, [_vm._v("Yes, I’d like to subscribe to the AirAsia newsletter to receive updates about travel news, deals and offers.")])]), _vm._v(" "), _c('div', {
    staticClass: "c-enter__submit"
  }, [_c('button', {
    staticClass: "c-button c-button--primary c-button--small",
    class: {
      'c-button--loading': _vm.loading
    },
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.submitEnter($event)
      }
    }
  }, [_vm._v("OPEN THE SECRET SCROLL TO IKIGAI")])])])]), _vm._v(" "), _c('svg', {
    staticClass: "c-scroll__shadow c-scroll__shadow--bottom",
    attrs: {
      "width": "532.4",
      "height": "81.28",
      "preserveAspectRatio": "xMinYMax meet",
      "viewBox": "0 0 532.4 81.28",
      "role": "presentation"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#cfa973",
      "d": "M0 12.28L532.4 0v81.28H0z"
    }
  })])]), _vm._v(" "), _c('img', {
    staticClass: "c-scroll__bottom",
    attrs: {
      "src": (_vm.baseUrl + "img/scroll/bottom.svg"),
      "alt": ""
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('h3', [_vm._v("You did it!")]), _vm._v(" "), _c('p', [_vm._v("Submit your entry now for a chance to "), _c('span', [_vm._v("WIN 2x return flights to Japan")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "terms"
    }
  }, [_vm._v("I agree to the "), _c('a', {
    attrs: {
      "href": "https://www.jnto.org.au/app/uploads/2018/06/JNTO_Scrolls_Of_Ikigai_Terms_Conditions_May_24th.pdf",
      "target": "_blank"
    }
  }, [_vm._v("Terms & Conditions")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "https://www.airasia.com/my/en/about-us/privacy-policy.page",
      "target": "_blank"
    }
  }, [_vm._v("AirAsia's privacy policy")])])
}]}

/***/ }),
/* 65 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "c-section c-section--complete",
    style: (("background-image: url(" + _vm.baseUrl + "img/bg-colors.svg)"))
  }, [_c('main-header'), _vm._v(" "), _c('div', {
    staticClass: "c-section__item"
  }, [_c('div', {
    staticClass: "o-container o-container--medium"
  }, [_c('div', {
    staticClass: "c-complete-intro"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "c-complete-intro__column"
  }, [_c('div', {
    staticClass: "c-complete-intro__img"
  }, [_c('img', {
    attrs: {
      "src": (_vm.baseUrl + "img/chest-complete.png"),
      "alt": ""
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "c-section__item"
  }, [_c('div', {
    staticClass: "o-container o-container--medium"
  }, [_c('div', {
    staticClass: "c-complete-inari"
  }, [_c('div', {
    staticClass: "c-inari c-inari--complete"
  }, [_c('img', {
    attrs: {
      "src": (_vm.baseUrl + "img/inari.svg"),
      "alt": "INARI"
    }
  })]), _vm._v(" "), _vm._m(1)])])]), _vm._v(" "), _c('div', {
    staticClass: "c-section__item"
  }, [_c('div', {
    staticClass: "o-container o-container--large"
  }, [_c('div', {
    staticClass: "c-scroll c-scroll--complete"
  }, [_c('img', {
    staticClass: "c-scroll__top",
    attrs: {
      "src": (_vm.baseUrl + "img/scroll/top-complete.svg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "c-scroll__middle"
  }, [_c('div', {
    staticClass: "c-complete-scroll"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "c-arrow-down"
  }), _vm._v(" "), _c('div', {
    staticClass: "c-complete-scroll__container"
  }, [_c('div', {
    staticClass: "c-complete-scroll--section c-complete-scroll__intro"
  }, [_c('div', {
    staticClass: "c-old-man"
  }, [_c('img', {
    attrs: {
      "src": (_vm.baseUrl + "img/old-man.svg"),
      "alt": "",
      "width": "85"
    }
  })]), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "c-complete-scroll--section c-complete-scroll__what"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "c-bed-rise"
  }, [_c('img', {
    attrs: {
      "src": (_vm.baseUrl + "img/bed-rise.svg"),
      "alt": "",
      "width": "285"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "c-complete-scroll--section c-complete-scroll__flower"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "c-flower-diagram"
  }, [_c('img', {
    attrs: {
      "src": (_vm.baseUrl + "img/flower-diagram.svg"),
      "alt": "",
      "width": "425"
    }
  })])]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "c-complete-scroll--section c-complete-scroll__steps"
  }, [_c('h3', [_vm._v("The 8 steps of ikigai")]), _vm._v(" "), _c('tiny-slider', {
    ref: "stepsSlider",
    staticClass: "c-slider c-slider--steps",
    attrs: {
      "controls": true,
      "controlsText": ['<span>Previous</span>', '<span>Next</span>'],
      "nav": true,
      "arrowKeys": true,
      "mouse-drag": true,
      "loop": true,
      "items": "1"
    }
  }, [_c('div', {
    staticClass: "c-slider__slide"
  }, [_c('header', [_c('h4', [_vm._v("1. Slow down and smell the cherry blossoms")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": (_vm.baseUrl + "img/steps/cherry-blossoms.svg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "s-entry-content"
  }, [_c('p', [_vm._v("Modern life moves fast. Slow down and you might just find that what you’re chasing will catch up to you. Take a break from technology and live in the moment. Let your senses enjoy the sights and sounds of your surroundings.")]), _vm._v(" "), _c('p', [_vm._v("Take Action: Clear your mind with a 25 minute walk. Leave your phone at home.")])])]), _vm._v(" "), _c('div', {
    staticClass: "c-slider__slide"
  }, [_c('header', [_c('h4', [_vm._v("2. Immerse yourself in what fulfills you")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": (_vm.baseUrl + "img/steps/singing.svg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "s-entry-content"
  }, [_c('p', [_vm._v("When we focus our energy in the wrong places, we only have time to scratch the surface of life. The greatest experiences come when we dive in with 100% commitment, allowing it to consume us completely. It can take up to ten years to become a sushi chef!")]), _vm._v(" "), _c('p', [_vm._v("Take Action: Spend 10 minutes working on your passion every day for the next 30 days.")])])]), _vm._v(" "), _c('div', {
    staticClass: "c-slider__slide"
  }, [_c('header', [_c('h4', [_vm._v("3. Find your zen"), _c('span', [_vm._v(" ")])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": (_vm.baseUrl + "img/steps/zen-man.svg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "s-entry-content"
  }, [_c('p', [_vm._v("In Japan, we have practiced meditation for over 1500 years. Meditation allows us to focus and control our emotions and outlook on life amidst daily distractions and brings us closer to finding our zen. Silence is full of answers.")]), _vm._v(" "), _c('p', [_vm._v("Take Action: Meditate for 15-30 minutes twice per week.")])])]), _vm._v(" "), _c('div', {
    staticClass: "c-slider__slide"
  }, [_c('header', [_c('h4', [_vm._v("4. Work to live, don’t live to work")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": (_vm.baseUrl + "img/steps/work.svg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "s-entry-content"
  }, [_c('p', [_vm._v("Fulfilling work is healthy for the soul but when life is taken over by work, the soul has no room to grow. It is also important to reflect if your work still aligns with your values and benefits society.")]), _vm._v(" "), _c('p', [_vm._v("Take Action: Is your work taking time away from yourself and the people that matter to you? Make changes if necessary.")])])]), _vm._v(" "), _c('div', {
    staticClass: "c-slider__slide"
  }, [_c('header', [_c('h4', [_vm._v("5. Prioritise your goals")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": (_vm.baseUrl + "img/steps/goals.svg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "s-entry-content"
  }, [_c('p', [_vm._v("In modern life, we are often pulled in many directions at the same time. It’s impossible to please everyone, so you need to prioritise what's most important to you first. If you are not making your own goals, you are probably working on someone else's.")]), _vm._v(" "), _c('p', [_vm._v("Take Action: Write down short term and long term goals and give each one a specific time frame.")])])]), _vm._v(" "), _c('div', {
    staticClass: "c-slider__slide"
  }, [_c('header', [_c('h4', [_vm._v("6. Try something new")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": (_vm.baseUrl + "img/steps/new-drum.svg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "s-entry-content"
  }, [_c('p', [_vm._v("It’s important to preserve our childlike curiosity. This will open up new paths for us. It takes many strokes to paint your life. Keep learning and add new strokes to the canvas. Soon, you’ll be able to see your ikigai within the masterpiece.")]), _vm._v(" "), _c('p', [_vm._v("Take Action: Whether you’re at home or travelling to Japan, look at what activities or classes are available in your area.")])])]), _vm._v(" "), _c('div', {
    staticClass: "c-slider__slide"
  }, [_c('header', [_c('h4', [_vm._v("7. Take action today")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": (_vm.baseUrl + "img/steps/rocket.svg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "s-entry-content"
  }, [_c('p', [_vm._v("Procrastination will steal your time away and take you further away from your goals. Stop talking of tomorrow and start taking steps to finding your ikigai.")]), _vm._v(" "), _c('p', [_vm._v("Take Action: Print out and fill in your own MyikiGuide (below)")])])]), _vm._v(" "), _c('div', {
    staticClass: "c-slider__slide"
  }, [_c('header', [_c('h4', [_vm._v("8. Just keep going")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": (_vm.baseUrl + "img/steps/rock-climbing.svg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "s-entry-content"
  }, [_c('p', [_vm._v("Your journey to discovering your ikigai will require persistence. Most people don’t find their passion straight away, sometimes it takes at least a few tries until you find something which truly fulfills you.")]), _vm._v(" "), _c('p', [_vm._v("Take Action: When you hit a barrier, take a breath, then carry on.")])])])])], 1), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8)]), _vm._v(" "), _c('div', {
    staticClass: "c-arrow-down"
  }), _vm._v(" "), _c('div', {
    staticClass: "c-complete-scroll--section c-myikiguide"
  }, [_c('img', {
    staticClass: "c-myikiguide__img",
    attrs: {
      "src": (_vm.baseUrl + "img/myikiguide.png"),
      "alt": "MyIkiGuide"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "c-button c-button--primary",
    attrs: {
      "href": "https://www.jnto.org.au/app/uploads/2018/05/Myikiguide.pdf?utm_medium=Website&utm_source=Website&utm_campaign=SecretScrolls&utm_content=Myikiguide",
      "download": "",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.$ga.event('SecretScrolls', 'Click', 'Download MyIkiguide');
      }
    }
  }, [_vm._v("DOWNLOAD MYIKIGUIDE AS PDF")])]), _vm._v(" "), _c('div', {
    staticClass: "c-complete-scroll--section c-complete-scroll__passions"
  }, [_c('h3', [_vm._v("Passions")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("Japan is filled with endless passions for you to pursue. Here are three examples:")]), _vm._v(" "), _c('tiny-slider', {
    ref: "passionsSlider",
    staticClass: "c-slider c-slider--3col c-slider--passions",
    attrs: {
      "controls": true,
      "controlsText": ['<span>Previous</span>', '<span>Next</span>'],
      "nav": true,
      "arrowKeys": true,
      "mouse-drag": true,
      "loop": true,
      "items": "1"
    }
  }, [_c('div', {
    staticClass: "c-slider__slide"
  }, [_c('header', [_c('h4', [_vm._v("Food")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": (_vm.baseUrl + "img/passions/food.svg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "s-entry-content"
  }, [_c('p', [_vm._v("If cooking is your passion, then follow your nose to Kagawa Prefecture on Shikoku Island. It is renowned for producing the country’s best tasting udon noodles with over 800 udon noodle shops to choose from. Here, there are many udon-making classes you can take to learn the full process including dough kneading and udon cutting from local masters.")])])]), _vm._v(" "), _c('div', {
    staticClass: "c-slider__slide c-slider__slide--green"
  }, [_c('header', [_c('h4', [_vm._v("Martial Arts")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": (_vm.baseUrl + "img/passions/martial-arts.svg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "s-entry-content"
  }, [_c('p', [_vm._v("Keeee-yah! If you’re a karate enthusiast, then you have to visit Okinawa - the birthplace of karate. There are approximately 400 dojos (schools) for you to perfect your roundhouse kick. There’s even a famous bar dedicated to karate with rare memorabilia, exhibits and plenty of Japanese whisky!")])])]), _vm._v(" "), _c('div', {
    staticClass: "c-slider__slide c-slider__slide--gold"
  }, [_c('header', [_c('h4', [_vm._v("Art")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": (_vm.baseUrl + "img/passions/art.svg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "s-entry-content"
  }, [_c('p', [_vm._v("For the artistic eye, the Setouchi region has your name written on its canvas. The island of Teshima is home to some of the most beautiful architecture in the world such as the Teshima Art Museum while the island of Naoshima is studded with modern art museums designed by the likes of Tadao Ando, artworks from Monet and Matisse, and iconic outdoor sculptures.")])])])])], 1)])]), _vm._v(" "), _c('img', {
    staticClass: "c-scroll__bottom",
    attrs: {
      "src": (_vm.baseUrl + "img/scroll/bottom-complete.svg"),
      "alt": ""
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "c-section__item"
  }, [_c('div', {
    staticClass: "o-container o-container--medium"
  }, [_c('div', {
    staticClass: "c-complete-outro"
  }, [_c('a', {
    staticClass: "c-button c-button--primary",
    attrs: {
      "href": "https://www.jnto.org.au/app/uploads/2018/05/Printable-Scroll.pdf?utm_medium=Website&utm_source=Website&utm_campaign=SecretScrolls&utm_content=Scroll",
      "download": "",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.$ga.event('SecretScrolls', 'Click', 'Download Scroll');
      }
    }
  }, [_vm._v("DOWNLOAD SCROLL")])]), _vm._v(" "), _c('ul', {
    staticClass: "c-social"
  }, [_c('li', [_c('button', {
    staticClass: "c-button c-button--alt c-button--facebook",
    on: {
      "click": function($event) {
        _vm.popup('Facebook')
      }
    }
  }, [_c('icon', {
    staticClass: "c-button__icon",
    attrs: {
      "name": "facebook",
      "role": "img",
      "label": "Facebook"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Share on Facebook")])], 1)]), _vm._v(" "), _c('li', [_c('button', {
    staticClass: "c-button c-button--alt c-button--twitter",
    on: {
      "click": function($event) {
        _vm.popup('Twitter')
      }
    }
  }, [_c('icon', {
    staticClass: "c-button__icon",
    attrs: {
      "name": "twitter",
      "role": "img",
      "label": "Twitter"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Share on Twitter")])], 1)]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "c-button c-button--alt c-button--email",
    attrs: {
      "href": "mailto:?subject=Can%20you%20unlock%20the%20Secret%20Scrolls%20of%20Ikigai%3F&body=The%20pursuit%20of%20your%20true%20passion%20can%20lead%20to%20unthinkably%20wonderful%20things.%20What%20are%20they%3F%20That%E2%80%99s%20for%20you%20to%20find%20out.%0A%0AYour%20journey%20to%20all%20the%20answers%20begin%20here.%20Unlock%20the%20secrets%20of%20ikigai%20and%20you%20can%20be%20in%20the%20chance%20to%20win%20return%20flights%20to%20Japan%20for%20you%20and%20your%20friend%20and%20become%20one%20step%20closer%20to%20discovering%20your%20ikigai%20in%20Japan.%0A%0Ahttp%3A%2F%2Fwww.jnto.org.au%2Fsecretscrolls%3Futm_medium%3DEmail%26utm_source%3DWebsite%26utm_campaign%3DSecretScrolls"
    },
    on: {
      "click": function($event) {
        _vm.$ga.event('SecretScrolls', 'Click', 'ShareEmail');
      }
    }
  }, [_c('icon', {
    staticClass: "c-button__icon",
    attrs: {
      "name": "email",
      "role": "img",
      "label": "Email"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Share by Email")])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "c-complete__footer"
  }, [_c('img', {
    attrs: {
      "src": (_vm.baseUrl + "img/bg-bottom.svg"),
      "alt": ""
    }
  })])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-complete-intro__column s-entry-content s-entry-content--large"
  }, [_c('p', [_c('em', [_vm._v("Your entry has been successfully submitted!")])]), _vm._v(" "), _c('p', [_vm._v("The time has now come. The secret Scroll of Ikigai is now open. From this point on, your life will never be the same again…")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-complete-inari__bubble"
  }, [_c('div', {
    staticClass: "s-entry-content"
  }, [_c('p', [_vm._v("I.N.A.R.I. Yes. I named the passcode after myself, hehe. Sometimes, the answers right in front of you are the hardest to see.")]), _vm._v(" "), _c('p', [_vm._v("I now present you, the secret Scroll of Ikigai. Use it wisely and may it serve you well along the journey to discovering your ikigai in Japan.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('h2', [_vm._v("THE SECRET SCROLL OF IKIGAI")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "s-entry-content"
  }, [_c('p', {
    staticClass: "lead"
  }, [_vm._v("Breathe in... and out.")]), _vm._v(" "), _c('p', [_vm._v("Clear your mind of distractions, it’s time to listen to what your heart truly desires and visualise your true passions.")]), _vm._v(" "), _c('p', [_vm._v("On the island of Okinawa, in southern Japan, ikigai is the way of life. The island also has the highest number of centenarians in the world. Some say this is more than coincidence.")]), _vm._v(" "), _c('p', [_vm._v("Are you ready to learn the secret of harnessing your ikigai?")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "s-entry-content"
  }, [_c('h3', [_vm._v("What is ikigai?")]), _vm._v(" "), _c('p', [_vm._v("Ikigai is an age-old Japanese concept that means ‘your reason for being’. Your ikigai is what drives you to get up in the morning. It gives you purpose, and with it, can lead to what we keep searching for... longevity and joyful living.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "s-entry-content"
  }, [_c('h3', [_vm._v("Ikigai is a mix of:")]), _vm._v(" "), _c('ul', {
    staticClass: "c-flower-list"
  }, [_c('li', [_vm._v("Your passion")]), _vm._v(" "), _c('li', [_vm._v("Your purpose")]), _vm._v(" "), _c('li', [_vm._v("Your satisfaction")]), _vm._v(" "), _c('li', [_vm._v("Your fulfillment")]), _vm._v(" "), _c('li', [_vm._v("Your calling")]), _vm._v(" "), _c('li', [_vm._v("Your true self")]), _vm._v(" "), _c('li', [_vm._v("Your values")]), _vm._v(" "), _c('li', [_vm._v("What’s good for society")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-complete-scroll--section c-complete-scroll__quote"
  }, [_c('div', {
    staticClass: "s-entry-content"
  }, [_c('blockquote', [_c('p', [_vm._v("A musician must make music, an artist must paint, a poet must write, if he is to be ultimately at peace with himself. What a man can be, he must be")])]), _vm._v(" "), _c('figcaption', [_vm._v("Abraham Maslow")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-complete-scroll--section c-complete-scroll__quote"
  }, [_c('div', {
    staticClass: "s-entry-content"
  }, [_c('blockquote', {
    staticClass: "c-blockquote--fw"
  }, [_c('p', [_vm._v("What gets you up in the morning (besides your alarm clock)? Mine is deep-fried tofu mmmmm")])]), _vm._v(" "), _c('figcaption', [_vm._v("Inari Fox")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-complete-scroll--section c-complete-scroll__guide"
  }, [_c('div', {
    staticClass: "s-entry-content"
  }, [_c('h3', [_vm._v("MyikiGuide")]), _vm._v(" "), _c('p', [_vm._v("Print out the ‘MyikiGuide’ and fill it in to help you determine your true passion.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("STEPS:")])]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("Write down your interests on the left hand column.")]), _vm._v(" "), _c('li', [_vm._v("For each interest, rate how much it applies to each of the 8 elements of ikigai across the other columns out of 10 (10 being very strong).")]), _vm._v(" "), _c('li', [_vm._v("Add up the ratings and write your total on the right hand column.")]), _vm._v(" "), _c('li', [_vm._v("The interest with the highest total may be your true ikigai!")])])])])
}]}

/***/ }),
/* 66 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "o-body-wrap",
    attrs: {
      "id": "app"
    }
  }, [_c('main', {
    staticClass: "c-main",
    attrs: {
      "id": "main",
      "role": "main"
    }
  }, [(_vm.view == 'default') ? _c('home') : _vm._e(), _vm._v(" "), (_vm.view == 'riddles') ? _c('game') : _vm._e(), _vm._v(" "), _c('promotions')], 1)])
},staticRenderFns: []}

/***/ }),
/* 67 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "o-body-wrap",
    attrs: {
      "id": "app"
    }
  }, [_c('main', {
    staticClass: "c-main",
    attrs: {
      "id": "main",
      "role": "main"
    }
  }, [_c('complete'), _vm._v(" "), _c('promotions')], 1)])
},staticRenderFns: []}

/***/ }),
/* 68 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "finalRiddle",
    staticClass: "c-final-riddle"
  }, [_c('div', {
    staticClass: "c-inari c-final-riddle__inari",
    class: {
      'c-inari--active': _vm.stage === 5
    }
  }, [_c('img', {
    attrs: {
      "src": (_vm.baseUrl + "img/inari.svg"),
      "alt": "INARI"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "c-final-riddle__lock"
  }, [_c('img', {
    attrs: {
      "src": (_vm.baseUrl + "img/lock.svg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "c-final-riddle__wrap"
  }, [_c('div', {
    staticClass: "c-final-riddle__inner"
  }, [_c('h4', [_vm._v("Now for the final riddle!")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.questions[_vm.randomIndex].question))]), _vm._v(" "), _c('form', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.finalAnswer),
      expression: "finalAnswer"
    }],
    attrs: {
      "type": "number",
      "placeholder": "Your Answer",
      "min": "0"
    },
    domProps: {
      "value": (_vm.finalAnswer)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.finalAnswer = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "c-button c-button--primary c-button--thin",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.submitFinal($event)
      }
    }
  }, [(!_vm.checkingAnswer) ? _c('span', [_vm._v("Submit")]) : _vm._e(), (_vm.checkingAnswer) ? _c('img', {
    attrs: {
      "src": (_vm.baseUrl + "img/spinner.svg"),
      "alt": "Loading",
      "width": "30"
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.finalAnswerError),
      expression: "finalAnswerError"
    }],
    staticClass: "c-form__hint"
  }, [_vm._v("HINT: " + _vm._s(_vm.questions[_vm.randomIndex].hint))])])])])])
},staticRenderFns: []}

/***/ }),
/* 69 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "c-section c-section--promotions"
  }, [_c('div', {
    staticClass: "o-container o-container--large"
  }, [_c('header', [_c('h2', [_vm._v("Discover your ikigai in Japan with")]), _vm._v(" "), _c('a', {
    staticClass: "c-promotions-logo",
    attrs: {
      "href": "https://www.airasia.com/en/home.page?utm_medium=display&utm_source=jnto&utm_campaign=d7_au_ptmkt%7Cjnto%7C04062018%7Cau-en",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.$ga.event('SecretScrolls', 'Click', 'AirAsia Footer Logo');
      }
    }
  }, [_c('img', {
    attrs: {
      "src": (_vm.baseUrl + "img/airasia.svg"),
      "alt": "AirAsia"
    }
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "c-promotions"
  }, _vm._l((_vm.promotions), function(promo) {
    return _c('li', {
      staticClass: "c-promotions__item"
    }, [_c('div', {
      staticClass: "c-promotions__route"
    }, [_vm._v("\n          " + _vm._s(promo.from) + " "), _c('icon', {
      attrs: {
        "name": "plane",
        "role": "presentation",
        "label": "Plane"
      }
    }), _vm._v(" " + _vm._s(promo.to) + "\n        ")], 1), _vm._v(" "), _c('div', {
      staticClass: "c-promotions__price"
    }, [_vm._v("\n          from "), _c('span', [_vm._v("$" + _vm._s(promo.price)), _c('sup', [_vm._v("*")])])]), _vm._v(" "), _c('a', {
      staticClass: "c-button c-button--secondary c-button--thin",
      attrs: {
        "href": "https://www.airasia.com/au/en/promotion.page?rr=rr1530605&utm_medium=display&utm_source=jnto&utm_campaign=d7_au_ptmkt%7Cjnto%7C04062018%7Cau-en",
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          _vm.$ga.event('SecretScrolls', 'Click', ("Book Now " + (promo.from) + " " + (promo.to)));
        }
      }
    }, [_vm._v("Book Now")])])
  })), _vm._v(" "), _c('p', {
    staticClass: "c-promotions__conditions"
  }, [_vm._v("*Conditions apply. See airasia.com for details. Processing fees may apply.")])])])
},staticRenderFns: []}

/***/ }),
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 76 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[20]);


// WEBPACK FOOTER //
// js/app.js